import React from "react";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { Header } from "common/Components/Header";
import classnames from "classnames";
import { app_route_keys, app_route_titles } from "constants/urlPaths";
import commonStyles from "../../CommonStyles.module.css";
import { ListingHeaderStatsSection } from "../ListingHeaderStatsSection";
import { SessionParticipantsTable } from "../SessionParticipantsTable";
import LearnMoreCta from "features/Common/modules/LearnMore/modules/LearnMoreCta/LearnMoreCta";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../../constants/ZoomAttendance.constants";

import {
  SessionParticipantsProvider,
  useSessionParticipantsContext,
} from "./context/SessionParticipantsContext";
import { SessionParticipantsModals } from "./components/SessionParticipantsModals";

const SessionParticipantsContent = (props) => {
  const isDesktop = useDesktopMediaQuery();
  const { handleBack, handleLearnMoreClick } = useSessionParticipantsContext();

  const HeaderComponent = (
    <Header
      title={
        app_route_titles[app_route_keys.zoom_attendance_session_participants] ||
        ZOOM_ATTENDANCE_CONSTANTS.LABELS.SESSION_PARTICIPANTS
      }
      hideBackButton={!isDesktop}
      onBack={handleBack}
      right={<LearnMoreCta onClick={handleLearnMoreClick} href="" />}
      classNames={{
        container: classnames("border-0 p-0", commonStyles.largeText),
      }}
    />
  );

  return (
    <div className="tw-mt-5">
      {isDesktop && <div className="tw-mb-3 tw-px-5">{HeaderComponent}</div>}
      <ListingHeaderStatsSection />
      <SessionParticipantsTable
        {...props}
        tableTitle={!isDesktop ? HeaderComponent : null}
      />
      <SessionParticipantsModals />
    </div>
  );
};

export const SessionParticipantsPage = withComponentLibraryTheme((props) => (
  <SessionParticipantsProvider {...props}>
    <SessionParticipantsContent {...props} />
  </SessionParticipantsProvider>
));
